import React from "react";

export const BlogSkeleton: React.FC = () => {
  return (
    <div className="flex lg:flex-row flex-col lg:gap-0 gap-6">
      <div className="lg:w-[40%] md:overflow-y-auto overflow-x-auto rounded-[20px] lg:max-h-[611px] md:max-h-[675px] max-h-[611px] pr-2">
        <div className="flex md:flex-col flex-row gap-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="bg-[#0E0E10] md:min-w-auto min-w-full flex flex-col justify-end rounded-[20px] relative overflow-hidden animate-pulse"
            >
              <div
                className="bg-[#1a1a1a] w-full"
                style={{ aspectRatio: "16 / 9", minHeight: "200px" }}
              />
              <div className="px-6 py-5">
                <div className="bg-[#1a1a1a] rounded h-4 w-24 mb-3" />
                <div className="space-y-2 mb-3">
                  <div className="bg-[#1a1a1a] rounded h-5 w-full" />
                  <div className="bg-[#1a1a1a] rounded h-4 w-3/4" />
                </div>
                <div className="space-y-2 mb-3">
                  <div className="bg-[#1a1a1a] rounded h-3 w-full" />
                  <div className="bg-[#1a1a1a] rounded h-3 w-5/6" />
                  <div className="bg-[#1a1a1a] rounded h-3 w-4/5" />
                </div>
                <div className="bg-[#1a1a1a] rounded h-4 w-20" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:w-[60%] lg:pl-[40px] lg:block grid sm:grid-cols-2 grid-cols-1 gap-[24px]">
        {[...Array(3)].map((_, index) => (
          <div
            key={index}
            className="flex items-stretch lg:flex-row flex-col bg-[#0E0E10] rounded-[20px] overflow-hidden lg:mb-6 last:mb-0 animate-pulse"
          >
            <div
              className="bg-[#1a1a1a] sm:min-w-[300px] w-full"
              style={{ aspectRatio: "16 / 9", minHeight: "169px" }}
            />
            <div className="lg:px-[24px] lg:py-5 p-4 lg:grid grid-cols-[1fr_0.4fr] w-full">
              <div className="bg-[#1a1a1a] rounded h-4 w-20 col-start-2 -col-end-1 lg:text-right max-lg:mb-1" />
              <div className="space-y-2 -order-1">
                <div className="bg-[#1a1a1a] rounded h-5 w-full mb-2" />
                <div className="bg-[#1a1a1a] rounded h-5 w-3/4" />
              </div>
              <div className="space-y-2 max-lg:mb-2">
                <div className="bg-[#1a1a1a] rounded h-3 w-full" />
                <div className="bg-[#1a1a1a] rounded h-3 w-5/6" />
                <div className="bg-[#1a1a1a] rounded h-3 w-4/5" />
              </div>
              <div className="bg-[#1a1a1a] rounded h-4 w-20 self-end text-right" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

